import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { userInfo } from '../../redux/selectors/auth';
import { logout } from '../../redux/ducks/auth';
import User from '../../models/User';
import MainNavigation from '../MainNavigation';
import Header from '../Header';

function pageWrapper(WrappedPage, defaultTitle) {
  class Page extends React.PureComponent {
    state = {
      title: defaultTitle,
    };

    onUpdateTitle = (title) => {
      this.setState({ title });
    };

    render() {
      return (
        <div className="app app--main">
          <div className="app-content">
            <MainNavigation />

            <section className="app-main">
              <Header
                pageTitle={this.state.title}
                user={this.props.user}
                onLogout={this.props.onLogout}
              />
              <div className="appPage">
                <WrappedPage
                  onUpdateTitle={this.onUpdateTitle}
                  {...this.props}
                />
              </div>
            </section>
          </div>

          <footer className="footer app-footer has-text-light">
            <div className="container">
              <div className="content has-text-centered">
                <p>CollectMe &copy; 2019</p>
              </div>
            </div>
          </footer>
        </div>
      );
    }
  }

  Page.propTypes = {
    user: PropTypes.instanceOf(User).isRequired,
    onLogout: PropTypes.func.isRequired,
  };

  function mapStateToProps(state) {
    return {
      user: userInfo(state),
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      onLogout: () => {
        dispatch(logout());
      },
    };
  }

  return connect(mapStateToProps, mapDispatchToProps)(Page);
}

export default pageWrapper;



// WEBPACK FOOTER //
// ./src/components/containers/MainPage.jsx